/* Cart drawer + quick add — talks to /cart/add.js, /cart/change.js, /cart.js */
(function () {
  'use strict';

  var drawer, overlay, itemsEl, footEl, emptyEl, countBubbles, subtotalEl, errorEl;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Escape HTML in strings injected via innerHTML (defense against stored XSS via product/variant titles) */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    return window.A1 && A1.money ? A1.money(cents) : '$' + (cents / 100).toFixed(2);
  }

  /* Shopify CDN images resize with ?width=; keeps the drawer from loading full-size photos */
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
  }

  function label(name, fallback) {
    return (drawer && drawer.getAttribute('data-label-' + name)) || fallback;
  }

  function cache() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return false;
    overlay = document.querySelector('[data-cart-overlay]');
    itemsEl = drawer.querySelector('[data-cart-items]');
    footEl = drawer.querySelector('[data-cart-foot]');
    emptyEl = drawer.querySelector('[data-cart-empty]');
    errorEl = drawer.querySelector('[data-cart-error]');
    countBubbles = document.querySelectorAll('[data-cart-count]');
    subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    return true;
  }

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  function announce(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function render(cart) {
    countBubbles.forEach(function (b) { b.textContent = '(' + cart.item_count + ')'; });
    var hasItems = cart.items && cart.items.length > 0;
    footEl.hidden = !hasItems;
    emptyEl.hidden = hasItems;

    if (hasItems) {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var opts = (item.options_with_values || [])
          .filter(function (o) { return o.value !== 'Default Title'; })
          .map(function (o) { return o.value; }).join(' / ');
        var img = item.image
          ? '<img class="cart-item__img" src="' + esc(thumb(item.image)) + '" alt="' + esc(item.title) + '" width="80" height="80" loading="lazy">'
          : '';
        var savings = '';
        if (item.original_line_price > item.final_line_price) {
          savings = '<s class="price__compare">' + money(item.original_line_price) + '</s> ';
        }
        /* Apps often name discounts with internal codes (e.g. AOVAI_IIDW6KSR) — show "Free" / "Discount applied" instead */
        var discounts = '';
        if ((item.line_level_discount_allocations || []).length) {
          var title = item.line_level_discount_allocations[0].discount_application && item.line_level_discount_allocations[0].discount_application.title;
          var friendly = item.final_line_price === 0 ? label('free', 'Free')
            : (title && !/^[A-Z0-9_-]+$/.test(title) ? title : label('discount', 'Discount applied'));
          discounts = '<p class="cart-item__discount">' + esc(friendly) + '</p>';
        }
        return '<div class="cart-item" data-key="' + esc(item.key) + '">' + img +
          '<div><p class="cart-item__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
          (opts ? '<p class="cart-item__variant">' + esc(opts) + '</p>' : '') +
          discounts +
          '<div class="cart-item__row">' +
          '<span class="cart-item__qty">' +
          '<button type="button" data-qty="-1" aria-label="' + esc(label('decrease', 'Decrease quantity')) + '">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty="1" aria-label="' + esc(label('increase', 'Increase quantity')) + '">+</button>' +
          '</span>' +
          '<span class="cart-item__price">' + savings + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-remove>' + esc(label('remove', 'Remove')) + '</button>' +
          '</div></div>';
      }).join('');
      subtotalEl.textContent = money(cart.total_price);
    } else {
      itemsEl.innerHTML = '';
    }
    announce(cart);
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  /* Reads a Cart API response; rejects with Shopify's own message (e.g. "only 2 in stock") */
  function parse(r) {
    return r.json().then(function (data) {
      if (!r.ok || data.status) {
        var err = new Error(data.description || data.message || label('error', 'Something went wrong. Please try again.'));
        throw err;
      }
      return data;
    });
  }

  function changeLine(key, quantity) {
    showError('');
    drawer.classList.add('is-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(parse)
      .then(render)
      .catch(function (e) { showError(e.message); return refresh(); })
      .then(function () { drawer.classList.remove('is-busy'); });
  }

  /* Returns a promise; done(errorMessage|null) is kept for older callers */
  function addToCart(formData, done) {
    showError('');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(parse)
      .then(function () { return refresh(); })
      .then(function () {
        open();
        if (done) done(null);
      })
      .catch(function (e) {
        if (done) done(e.message);
        throw e;
      });
  }

  function init() {
    if (!cache()) return;

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        refresh().then(open);
      });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Quantity + remove inside the drawer (event delegation) */
    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.cart-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        var current = parseInt(row.querySelector('.cart-item__qty span').textContent, 10);
        changeLine(key, Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty'), 10)));
      }
      if (e.target.closest('[data-remove]')) changeLine(key, 0);
    });

    /* Quick add from product cards — delegated so cards loaded later (recommendations, recently viewed) work too */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('form[data-quick-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-adding-label') || 'Adding…';
      addToCart(new FormData(form))
        .catch(function (err) {
          open();
          showError(err.message);
        })
        .then(function () {
          btn.disabled = false;
          btn.innerHTML = original;
        });
    });

    /* Apps (e.g. free-gift / discount apps) can ask the drawer to re-read the cart */
    document.addEventListener('cart:refresh', function () { refresh(); });
    /* Coming back to the tab after changing the cart elsewhere */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh();
    });

    refresh();
  }

  /* Exposed for product.js */
  window.A1Cart = { addToCart: addToCart, open: open, close: close, refresh: refresh, showError: showError };

  document.addEventListener('DOMContentLoaded', init);
})();
